import Typography from "@mui/material/Typography";
import DetailItemInfo from "./DetailItemInfo";
import React, {useContext, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router";
import http from "../../../shared/http-common";
import {trackPromise} from "react-promise-tracker";
import {DataContext, RealmContext, TokenContext} from "../../Store";
import MaterialTable from "@material-table/core";
import {header} from "../../../shared/headerStyle";
import Button from "@mui/material/Button";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import DataobjectService from "../../../services/DataobjectService";
import DataObjectsEdit from "./DataObjectEdit";
import DataComponentEdit from "./DataComponentEdit";
import UploadDialog from "./UploadDialog";
import UserService from "../../../services/UserService";

// Style für DataTreeView
const styles = {
    root: {
        textAlign: "left",
        fontFamily: "poppins",
    },
    lightButton: {
        float: "right",
        fontWeight: "bold",
    },
    darkButton: {
        float: "right",
        color: "#e5e5e5",
        fontWeight: "bold",
    },
    table: {
        minWidth: 700,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
}

const GetObjectSubData = async (guid, objecttype, realm, token) => {
    try {
        let formData = new FormData();
        formData.append("realm", realm);
        formData.append("guid", guid);

        return await http.post(`/` + objecttype + `/getAllObjects`, formData,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            }
        });
    } catch (e) {
        console.error(e);
    }
}


function Dataobject() {
    const [token] = useContext(TokenContext);
    const [realm] = useContext(RealmContext);

    const location = useLocation();

    const dataObject = location.state.subObjects;
    const title = location.state.title;
    const selectedObjectType = location.state.objectType;

    const [myRealestate, setMyRealestate] = useState([]);
    const [myAdministrativeobjects, setMyAdministrativeobjects] = useState([]);

    const [DataComponentEditDialogOpen, setDataComponentEditDialogOpen] = useState(false);
    const [DataComponentFormDialogOpen, setDataComponentFormDialogOpen] = useState(false);
    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

    const [filtering, setFiltering] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const dataCtx = useContext(DataContext);
    const setDataobjectsDialogOpen = dataCtx.setDialogOpen;
    const [dataObjectSubSelected, setDataObjectSubSelected] = useState([]);

    const [myTableData, setMyTableData] = useState([]);

    let hideDeactivatedColumn = true

    const navigate = useNavigate()
    useEffect(()=>{
        if(!location?.state?.subObjects) {
            navigate('/DataobjectsList/'+ realm, {state: {objectType: selectedObjectType}});
        }
    },[])

    useEffect(() => {
        const objecttype = dataObject.realestateobjectTypeGuid ? 'realestateobject' : 'administrativeobject';
        async function fetchData() {
            setIsLoading(true);
            await trackPromise(
                (async () => {
                    const result = await GetObjectSubData(dataObject.guid, objecttype, realm, token);
                    setDataObjectSubSelected(result.data)
                    if(objecttype === 'realestateobject') {
                        setMyRealestate(result.data.subordinated);
                        setMyAdministrativeobjects(result.data.administrativeobjects);

                        const tempData = []
                        result?.data?.subordinated?.forEach((item)=>{
                            tempData.push({guid: item.guid, name: item.name, number: item.number, label: item.label, type: item.realestateobjectType, deactivated: item.deactivated, realestateobjectTypeGuid: item.realestateobjectTypeGuid});
                        })
                        result?.data?.administrativeobjects?.forEach((item)=>{
                            tempData.push({guid: item.guid, name: item.name, number: item.number, label: item.label, type: item.administrativeobjectType, deactivated: item.deactivated});
                        })
                        setMyTableData(tempData);
                    } else {
                        setMyRealestate(result.data.realestateobjects);
                        setMyAdministrativeobjects(result.data.subordinated);
                        const tempData = []
                        result?.data?.subordinated?.forEach((item)=>{
                            tempData.push({guid: item.guid, name: item.name, number: item.number, label: item.label, type: item.administrativeobjectType, deactivated: item.deactivated});
                        })
                        result?.data?.realestateobjects?.forEach((item)=>{
                            tempData.push({guid: item.guid, name: item.name, number: item.number, label: item.label, type: item.realestateobjectType, deactivated: item.deactivated, realestateobjectTypeGuid: item.realestateobjectTypeGuid});
                        })
                        setMyTableData(tempData);
                    }
                    setIsLoading(false);
                })()
            );
        }
        fetchData();
    },[dataObject, realm, token]);

    if(filtering) {
        hideDeactivatedColumn = false;
    }

    const goBack = () => {
        navigate('/DataobjectsList/' + realm, {state: {objectType: selectedObjectType}});
    }

    const handleDeactivateClick = async (object, event) => {
        event.preventDefault();
        setIsLoading(true);
        if(object.administrativeobjectTypeGuid) {
            await DataobjectService.deactivateAdministrativeobject(token, realm, object.guid);
            await GetObjectSubData(object.guid, realm, token);
            setIsLoading(false);
        } else if(object.realestateobjectTypeGuid) {
            await DataobjectService.deactivateRealestateobject(token, realm, object.guid);
            await GetObjectSubData(object.guid, realm, token);
            setIsLoading(false);
        }
    }

    const handleActivateClick = async (object, event) => {
        event.preventDefault();
        setIsLoading(true);
        if(object.administrativeobjectTypeGuid) {
            await DataobjectService.activateAdministrativeobject(token, realm, object.guid);
            await GetObjectSubData(object.guid, realm, token);
            setIsLoading(false);
        } else if(object.realestateobjectTypeGuid) {
            await DataobjectService.activateRealestateobject(token, realm, object.guid);
            await GetObjectSubData(object.guid, realm, token);
            setIsLoading(false);
        }
    }

    const handleEditClick = async (object) => {
        setIsLoading(true);
        if(object.administrativeobjectTypeGuid || checkObjectType(object.type) === 'administrativeobject') {
            const result = await DataobjectService.getAdministrativeObject(token, realm, object.guid);
            setDataObjectSubSelected(result.data);
            setDataobjectsDialogOpen(true);
            setIsLoading(false);
        } else if(object.realestateobjectTypeGuid || checkObjectType(object.type) === 'realestateobject') {
            const result = await DataobjectService.getRealestateObject(token, realm, object.guid);
            setDataObjectSubSelected(result.data);
            setDataobjectsDialogOpen(true);
            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    }

    const handleUploadClick = (event, item) => {
        event.preventDefault();
        setDataObjectSubSelected(item);
        setDataComponentEditDialogOpen(false);
        setUploadDialogOpen(true);
    }

    const handleComponentClick = (event, rowData) => {
        setDataObjectSubSelected(rowData);
        setDataComponentEditDialogOpen(true);
    }

    const reloadObjects = () => {}

    const checkObjectType = (type) => {
        let objecttype = '';
        switch (type) {
            case 'Liegenschaft':
            case 'Bauwerk':
            case 'Gebäude':
            case 'Raum':
            case 'Geschoss':
            case 'Spielplatz':
                objecttype = 'realestateobject';
                break;
            case 'Wirtschaftseinheit':
            case 'Wohnung':
            case 'Mieteinheit':
            case 'Gewerbeeinheit':
            case 'Stellplatz':
            case 'Hauseingang':
            case 'Flurstück':
            case 'Gebietsgliederung':
            case 'Waschhaus':
                objecttype = 'administrativeobject';
                break;

        }
        return objecttype;
    }


    const tableHeight =(window.innerHeight -57 - 74 - 52) / window.innerHeight * 100;

    return (
        <>
            <div onClick={goBack} className="backline" >
                <Button style={{color: '#ffffff'}}><ChevronLeftIcon />Zurück</Button>
            </div>
            <Typography variant="body2" component="p">
               <MaterialTable
                data={myTableData}
                title={title}
                columns={[
                    { title: 'Bezeichnung', field: 'name' },
                    { title: 'Nummer', field: 'number'},
                    { title: 'Kennzeichen', field: 'label' },
                    { title: 'Typ', field: 'type'},
                    { title: 'deaktiviert', field: 'deactivated', lookup: { 0: 'nein', 1: 'ja' }, hidden: hideDeactivatedColumn }
                ]}
                options={{
                    headerStyle: header,
                    rowStyle: rowData => ({
                        backgroundColor: (rowData.deactivated) ? '#EEE' : '#FFF',
                        display: (hideDeactivatedColumn && rowData.deactivated) ? 'none': ''
                    }),
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100],
                    actionsColumnIndex: -1,
                    filtering,
                    exportButton: true,
                    exportAllData: true,
                    maxBodyHeight: `${tableHeight}vh`,
                    minBodyHeight: `${tableHeight}vh`,
                }}
                isLoading={isLoading}
                onRowClick={(event, rowData) => {
                    navigate('/Dataobject', {state: {subObjects: rowData, title: rowData.name, objectType: selectedObjectType}})
                }}
                localization={{
                    pagination: {
                        labelDisplayedRows: '{from}-{to} von {count}',
                        labelRowsSelect: 'Zeilen',
                        labelRowsPerPage: 'Zeilen pro Seite',
                        firstTooltip: "Erste Seite",
                        previousTooltip: "Vorherige Seite",
                        nextTooltip: "Nächste Seite",
                        lastTooltip: "Letzte Seite",
                    },
                    toolbar: {
                        nRowsSelected: '{0} Zeile(n) ausgewählt',
                        searchTooltip: 'Suchen',
                        searchPlaceholder: 'Suchbegriff eingeben'
                    },
                    header: {
                        actions: 'Aktionen'
                    },
                    body: {
                        emptyDataSourceMessage: 'Keine Einträge gefunden',
                        filterRow: {
                            filterTooltip: 'Filter'
                        }
                    }
                }}
                actions={[
                    {
                        icon: 'edit',
                        tooltip: 'Editieren',
                        onClick: (event, rowData) => handleEditClick(rowData),
                        disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                    },
                    rowData => ({
                        icon:  rowData.deactivated ? 'taskalt' : 'cancel',
                        tooltip: rowData.deactivated ? 'Aktivieren': 'Deaktivieren',
                        onClick: rowData.deactivated ? (event, rowData) => handleActivateClick(rowData, event) :(event, rowData) => handleDeactivateClick(rowData, event),
                        disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                    }),
                    rowData => (checkObjectType(rowData.type) === 'realestateobject') ? {
                        icon: 'hardware',
                        tooltip: 'Bauteile',
                        onClick: (event, rowData) => handleComponentClick(event, rowData)
                    } : '',
                    {
                        icon: 'upload',
                        tooltip: 'Upload',
                        onClick: (event, rowData) => handleUploadClick(event, rowData),
                        disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                    }

                ]}
               />
            </Typography>
            <DataObjectsEdit dataObjectSelected={dataObjectSubSelected}
                             handleDeactivateClick={handleDeactivateClick}
                             handleActivateClick={handleActivateClick}
                             reloadObjects={reloadObjects}
            />
            <DataComponentEdit
                dataObjectSelected={dataObjectSubSelected}
                setDataComponentEditDialogOpen={setDataComponentEditDialogOpen}
                DataComponentEditDialogOpen={DataComponentEditDialogOpen}
                handleUploadClick={handleUploadClick}
                setDataComponentFormDialogOpen={setDataComponentFormDialogOpen}
                DataComponentFormDialogOpen={DataComponentFormDialogOpen}
            />
            <UploadDialog
                dataObjectSelected={dataObjectSubSelected}
                setUploadDialogOpen={setUploadDialogOpen}
                uploadDialogOpen={uploadDialogOpen}
            />
        </>
    );
}

export default Dataobject;
